import { SOURCE_CRG } from '@rsos/components/capstone/common/Map/SpatialLayers/spatialLayersSources';
import { ESRI } from '@rsos/constants/mapProviders';
import { GISServiceTypes, type GISStateLayer } from '@rsos/reduxDataStore';

const CRG_TEXT_PATTERN = /crg/i;

/**
 * True when a string looks like a CRG label (title/subtitle/display name).
 */
export const textIncludesCRG = (value?: string | null): boolean =>
  typeof value === 'string' && CRG_TEXT_PATTERN.test(value);

/**
 * True when a GIS layer is the WFS-backed CRG service. Detected by WFS type
 * plus CRG in the admin title (`display_name` / layer.title) or Andromeda
 * subtitle (`attributes.subtitle`).
 */
export const isWFSCRGLayer = (layer: GISStateLayer): boolean => {
  if (layer.service?.service_type !== GISServiceTypes.wfs) {
    return false;
  }

  return (
    textIncludesCRG(layer.title) ||
    textIncludesCRG(layer.service?.display_name) ||
    textIncludesCRG(layer.service?.attributes?.subtitle)
  );
};

export const hasWFSCRGLayer = (gisLayers: GISStateLayer[] = []): boolean =>
  gisLayers.some(isWFSCRGLayer);

/**
 * Old Prague CRG spatial layers should stay available on Google Maps. On ESRI,
 * hide them when the agency also has the newer WFS CRG GIS layer so only one
 * CRG control is offered.
 */
export const shouldHideOldCRG = (
  mapProvider: string | undefined,
  gisLayers: GISStateLayer[] = [],
): boolean => mapProvider === ESRI && hasWFSCRGLayer(gisLayers);

export const isOldCRGSpatialLayer = (layer: { source?: string }): boolean =>
  layer.source === SOURCE_CRG;
